export default __webpack_public_path__ + "assets/images/Payment_10.5d5065.png";